import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
confirmEnviarIniciativa:boolean=false;

  constructor(public dialog:MatDialog,  
              @Inject(MAT_DIALOG_DATA) 
              public mensaje: string) 
              {}

  ngOnInit(): void {
  }

  //Cerrar el cuadro de dialogo
  closeDialog()
  {
    this.dialog.closeAll();
  }

}
